import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { generateClient } from 'aws-amplify/api';

@Injectable({
    providedIn: 'root'
})
export class AmplifyApiService {
    private amplifyClient = generateClient();

    graphql<T = unknown>(
        options: Parameters<typeof this.amplifyClient.graphql>[0]
    ) {
        return this.amplifyClient.graphql(options) as Promise<T>;
    }

    subscribe(
        options: Parameters<typeof this.amplifyClient.graphql>[0]
    ): Observable<any> {
        return this.amplifyClient.graphql(options) as Observable<any>;
    }
}
